import React from 'react';
import _ from 'lodash';
import $ from 'jquery';

import * as Misc from "./../../misc";
import ActionTypes from "./../../actionTypes";
import QuantityTextField from "./../quantityTextField";
import Config from "./../../config";
import ProjectScope from "./projectScope";
import HelpIcon from './helpIcon';
import Analytics from './../../analytics';

export default class FeatureBox extends React.Component {
  constructor(props) {
    super(props);

    const quote = ProjectScope.quote();
    this.state = {
      value: quote.features[this.props.feature.id] || 0,
      isEdge: /^edge profile[s]*/i.test(this.props.feature.name),
      isFaucet: /^faucet[s]/i.test(this.props.feature.name),
      focused: false
    };
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
  }

  handleQuoteDataChanged = () => {
    this.setState({value: ProjectScope.quote().features[this.props.feature.id] || 0});
  };

  click = (e) => {
    Analytics.sendClickEvent('feature-box: ' + this.props.feature.name);
    this.setState({
      value: this.state.value ? 0 : 1
    });
    Misc.ignoreDefault(e);
    this.props.click(this.props.feature);
  };

  handleValueChange = (value) => {
    Analytics.sendDataEnteredEvent('feature-data-entered: ' + this.props.feature.name);
    this.setState({
      value: value
    });
    this.props.valueChanged(this.props.feature, value);
  };

  handleHandleContainerClick = (e) => {
    Analytics.sendClickEvent('lightbox-input-container: ' + this.props.feature.name);
    Misc.ignoreDefault(e);
  };

  toggleFocusOff = () => {
    this.setState({
      focused: false
    });
    if (Config.isAndroid() || Config.isIphone()) {
      this.props.toggleFocusedFeauture(false);
    }
  };

  toggleFocusOn = () => {

    const f = this.props.feature;
    const qFlag = _.find(f.flags, function (f) {
      return f.indexOf('q') !== -1;
    });
    const isSelected = (_.indexOf(this.props.currentFeatures, f.id) !== -1 && f.unit !== 'No Quantity' && !qFlag) || this.state.value !== 0;

    if (this.props.isIndividual && f.unit !== 'No Quantity' && !isSelected) {
      !this.state.focused && this.setState({
        focused: true
      });
      // Config.isAndroid() && $('.lightbox-wrapper').animate({scrollTop: $('[data-id="'+f.id+'"]').position().top+150},600);
    }
    if (Config.isAndroid() || Config.isIphone()) {
      this.props.toggleFocusedFeauture(true);
    }
  };

  render() {
    const f = this.props.feature;
    const qFlag = _.find(f.flags, function (f) {
      return f.indexOf('q') !== -1;
    });
    const isSelected = (_.indexOf(this.props.currentFeatures, f.id) !== -1 && f.unit !== 'No Quantity' && !qFlag) || this.state.value !== 0;
    const style = {};
    const editStyle = {};
    const backgrounds = {
      round: "url('/content/Views/quickquote-v3/images/buttons/LightboxOvalSelected.svg')",
      square: "url('/content/Views/quickquote-v3/images/buttons/LightboxRectangleSelected.svg')"
    };

    if (Config.kioskStandAlone) {
      backgrounds.round = "url('../../images/buttons/LightboxOvalSelected.svg')";
      backgrounds.square = "url('../../images/buttons/LightboxRectangleSelected.svg')";
    }
    if (location.port === '9007') {
      backgrounds.round = "url('/images/buttons/LightboxOvalSelected.svg')";
      backgrounds.square = "url('/images/buttons/LightboxRectangleSelected.svg')";
    }
    if (isSelected || this.state.focused) {
      style.backgroundImage = this.props.isRound
        ? backgrounds.round
        : backgrounds.square;
      editStyle.borderColor = '#9FC522';
    }

    const classShape = this.props.isRound ? 'round' : 'rectangular';

    let classShapePostFix = '';
    if (this.state.isEdge) {
      classShapePostFix = '-edge';
    } else if (this.state.isFaucet) {
      classShapePostFix = '-faucet';
    }

    let loaderStyle = {
      backgroundImage: "url('" + f.imageUrl + "')"
    };

    let showTextField = _.trim(f.unit).toLowerCase() != 'no quantity';
    
    return (
      <div className={"lightbox-option-" + classShape} key={f.id} style={style} data-id={f.id}
           onClick={(showTextField) ? null : this.click}>
        <div className="lightbox-option-content" onClick={this.toggleFocusOn}>
          <HelpIcon feature={this.props.feature} isRound={this.props.isRound} title={f.displayName}/>
          <div className={"lightbox-option-" + classShape + "-loader" + classShapePostFix} style={loaderStyle}>
          </div>
          {showTextField ? (
            <div className="lightbox-input-container" onClick={this.handleHandleContainerClick}>
              <QuantityTextField className="lightbox-input" value={this.state.value} onChange={this.handleValueChange}
                                 style={editStyle} title="Feature quantity"
                                 toggleFocusOff={this.toggleFocusOff}
                                 toggleFocusOn={this.toggleFocusOn}
                                 focused={this.state.focused}
                                 hasFocusedFeauture={this.props.hasFocusedFeauture}
                                 lightBoxInput={true}
                                 placeHolder={f.unit}/>
            </div>
          ) : null}
          <div className="lightbox-description-text">{f.displayName}</div>
        </div>
      </div>
    );
  }
};





// WEBPACK FOOTER //
// ./src/components/projectScope/featureBox.js